export default [
    "24 24",
    '<path d="M12 4V20M12 20L18 14M12 20L6 14" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

